import React, { useEffect, useState } from "react";
import { FaUtensils, FaListAlt, FaStar } from "react-icons/fa";
import "./MainPage.css";

const COOKIE_CONSENT_KEY = "cookieConsentAcceptedAt";
const COOKIE_CONSENT_DURATION_MS = 60 * 24 * 60 * 60 * 1000;



function MainPage() {
    const [index, setIndex] = useState(0);
    const [showCookiePopup, setShowCookiePopup] = useState(false);

    const moveSlide = (direction) => {
        let newIndex = index + direction;

        if (newIndex < 0) newIndex = 9;   // 4 images → last index
        if (newIndex > 9) newIndex = 0;   // back to first

        setIndex(newIndex);

        const track = document.getElementById("sliderTrack");

        // ⭐ dynamic width — works on desktop + mobile
        const imgWidth = track.querySelector("img").clientWidth;

        track.style.transform = `translateX(-${newIndex * imgWidth}px)`;
    };

    useEffect(() => {
        const interval = setInterval(() => {
            moveSlide(1);
        }, 5000); // every 5 seconds

        return () => clearInterval(interval);
    });

    useEffect(() => {
        const savedConsent = localStorage.getItem(COOKIE_CONSENT_KEY);

        if (!savedConsent) {
            setShowCookiePopup(true);
            return;
        }

        const acceptedAt = Number(savedConsent);
        const isExpired = Number.isNaN(acceptedAt)
            || Date.now() - acceptedAt > COOKIE_CONSENT_DURATION_MS;

        setShowCookiePopup(isExpired);
    }, []);

    const handleAcceptCookies = () => {
        localStorage.setItem(COOKIE_CONSENT_KEY, String(Date.now()));
        setShowCookiePopup(false);
    };

    const handleDeclineCookies = () => {
        localStorage.setItem(COOKIE_CONSENT_KEY, String(Date.now()));
        setShowCookiePopup(false);
    };

    return (
        <>

            {/* GLOBAL SVG GRADIENT FOR STARS */}
            <svg width="0" height="0">
                <defs>
                    <linearGradient id="goldGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stopColor="#FFD700" />
                        <stop offset="100%" stopColor="#FFA500" />
                    </linearGradient>
                </defs>
            </svg>


            {/* NAVBAR */}
            <div className="navbar">
                {/* <div className="navbar-left">🔥 Imbiss Insel Unterliederbach</div> */}
                <div className="navbar-left">
                    🔥 <span className="neon-wrapper"><span className="neon-red">DÖNER</span></span> – Unterliederbach
                </div>

                <div className="navbar-right">
                    <a href="#menu" className="nav-icon"><FaUtensils /></a>
                    <a href="#angebot" className="nav-icon"><FaListAlt /></a>
                    <a href="#bewertungen" className="nav-icon"><FaStar /></a>
                </div>
            </div>

            {/* <div className="navbar">
        <div className="navbar-left">🔥 Imbiss Insel Unterliederbach</div>
        <div className="navbar-right">
          <a href="#menu">Menü</a>
          <a href="#angebot">Unser Angebot</a>
          <a href="#bewertungen">Bewertungen</a>
        </div>
      </div> */}


            {/* MENU SECTION */}
            <section id="menu" className="menu-section">
                <h2>Imbiss Insel</h2>

                {/* Red gradient line */}
                <div className="menu-line"></div>

                <p>Knuspriges Brot, saftiges Fleisch und frische Zutaten.</p>
            </section>

            {/* <section id="menu" className="menu-section">
                <h2>Unser Menü</h2>
                <p>Frisch, lecker und täglich für dich zubereitet.</p>
            </section> */}

            {/* MAIN IMAGE */}
            <div className="hero-image">
                <div className="hero-text">
                    <h1>Willkommen im Imbiss Insel Unterliederbach</h1>
                    <p>Echter Döner. Genuss, der verbindet.</p>
                </div>
            </div>

            {/* MENU SHOWCASE */}
            {/* <section className="menu-showcase-section" aria-label="Menü Vorschau">
                <div className="menu-showcase-image-wrap">
                    <img src="/img/menu5e.jpg" alt="Menü im Imbiss Insel" className="menu-showcase-image" />
                </div>
            </section> */}



            {/* MAP + SLIDER ROW */}
            <div className="row-sections">
                {/* GOOGLE MAPS */}
                {/* <section className="map-section">
                    <h2>Hier findest du uns</h2>
                    <p>Frankfurt am Main – Unterliederbach Bahnhof</p>

                    <iframe
                        title="Google Maps Schmalkaldener Str."
                        width="300"
                        height="300"
                        style={{ border: 0, borderRadius: "12px" }}
                        loading="lazy"
                        allowFullScreen
                        referrerPolicy="strict-origin-when-cross-origin"
                        // src="https://maps.google.com/maps?q=50.10833719154295,8.527484640526115&z=18&output=embed"
                           src="https://maps.google.com/maps?q=50.108337,8.527485&z=18&output=embed"
                    />
                </section> */}
                {/* MENU SECTION */}
                <section className="menu-section">
                    <h2>Menu</h2>
                    <p>Frisch zubereitete Klassiker und Spezialitaeten fuer jeden Geschmack.</p>
                    <div className="menu-showcase-image-wrap">
                        <img src="/img/menu599.jpg" alt="Menü im Imbiss Insel" className="menu-showcase-image" />
                    </div>
                </section>


                {/* GOOGLE MAPS */}
                <section className="map-section">
                    <h2>Hier findest du uns</h2>
                    <p>Frankfurt am Main – Schmalkaldener Str. 5 - Unterliederbach Bahnhof</p>

                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5117.5881363269855!2d8.524991683423597!3d50.10886139981492!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47bda0cf4ce167cb%3A0xaf7f4bfeae315b00!2sFrankfurt%20(Main)%20Unterliederbach%20Bahnhof!5e0!3m2!1sde!2sde!4v1783800234661!5m2!1sde!2sde"
                        width="600"
                        height="450"
                        style={{ border: 0 }}
                        allowFullScreen={true}
                        loading="lazy"
                        referrerPolicy="strict-origin-when-cross-origin"
                    ></iframe>
                </section>



                <section className="adv-section">
                    <h2>Advertising</h2>
                    <p>Hier kannst du Werbung schalten.</p>
                </section>


                {/* <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5117.5881363269855!2d8.524991683423597!3d50.10886139981492!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47bda0cf4ce167cb%3A0xaf7f4bfeae315b00!2sFrankfurt%20(Main)%20Unterliederbach%20Bahnhof!5e0!3m2!1sde!2sde!4v1783800234661!5m2!1sde!2sde" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="strict-origin-when-cross-origin"></iframe> */}
                {/* <iframe src="https://www.google.com/maps/embed?pb=!1m10!1m8!1m3!1d387.02051031032477!2d8.52782051467286!3d50.10826488635272!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sde!2sde!4v1783800103746!5m2!1sde!2sde" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="strict-origin-when-cross-origin"></iframe> */}




                {/* AUTO SLIDER WITH ARROWS */}
                <section className="auto-slider-section">
                    <h2>Bilder aus unserem Imbiss Insel</h2>

                    <div className="auto-slider-wrapper">
                        <button className="arrow left" onClick={() => moveSlide(-1)}>❮</button>

                        <div className="auto-slider">
                            <div className="auto-slider-track" id="sliderTrack">
                                <img src="../img/foto1.jpg" alt="Slider 1" />
                                <img src="../img/foto2.jpg" alt="Slider 2" />
                                <img src="../img/foto3.jpg" alt="Slider 3" />
                                <img src="../img/foto4.jpg" alt="Slider 4" />
                                <img src="../img/foto5.jpg" alt="Slider 5" />
                                <img src="../img/foto6.jpg" alt="Slider 6" />
                                <img src="../img/foto7.jpg" alt="Slider 7" />
                                <img src="../img/foto8.jpg" alt="Slider 8" />
                                <img src="../img/foto9.jpg" alt="Slider 9" />
                                <img src="../img/foto10.jpg" alt="Slider 10" />
                            </div>
                        </div>

                        <button className="arrow right" onClick={() => moveSlide(1)}>❯</button>
                    </div>
                </section>
            </div>



            {/* UNSER ANGEBOT */}
            {/* <section id="angebot" className="angebot-section">
                <h2>Unser Angebot</h2>
                <ul>
                    <li>Döner Kebap – klassisch oder mit extra Fleisch</li>
                    <li>Dürüm – frisch gerollt</li>
                    <li>Falafel – hausgemacht</li>
                    <li>Pide – traditionell aus dem Steinofen</li>
                    <li>Pommes – knusprig und heiß</li>
                </ul>
            </section> */}






            {/* UNSER ANGEBOT */}
            {/* <section id="angebot" className="angebot-section">
                <div className="menu-showcase-image-wrap">
                    <img src="/img/menuFoto.jpg" alt="Menü im Imbiss Insel" className="menu-showcase-image" />
                </div>
            </section> */}





            {/* BEWERTUNGEN */}
            <section id="bewertungen" className="bewertung-section">
                <h2>Bewertungen unserer Kunden</h2>

                <div className="review">
                    <div className="stars">
                    </div>
                    <p>„Bester Döner in Frankfurt! Frisch und super lecker.“ – Ümit</p>
                    <div className="stars">
                        <FaStar /><FaStar /><FaStar /><FaStar /><FaStar />
                    </div>
                </div>

                <div className="review">
                    <div className="stars">
                    </div>
                    <p>„Sehr freundliches Team und schnelle Bedienung.“ – Ayhan</p>

                    <div className="stars">
                        <FaStar /><FaStar /><FaStar /><FaStar /><FaStar />
                    </div>
                </div>
                <div className="review">
                    <div className="stars">
                    </div>
                    <p>„Der Dürüm ist ein Traum. Immer wieder gerne!“ – Tobi</p>
                    <div className="stars">
                        <FaStar /><FaStar /><FaStar /><FaStar /><FaStar />
                    </div>
                </div>
            </section>

            {/* BEWERTUNGEN
      <section id="bewertungen" className="bewertung-section">
        <h2>Bewertungen unserer Kunden</h2>
        <div className="review">
          <p>„Bester Döner in Frankfurt! Frisch und super lecker.“ – Markus</p>
        </div>
        <div className="review">
          <p>„Sehr freundliches Team und schnelle Bedienung.“ – Aylin</p>
        </div>
        <div className="review">
          <p>„Der Dürüm ist ein Traum. Immer wieder gerne!“ – Tom</p>
        </div>
      </section> */}

            {/* FOOTER */}
            <footer className="footer">
                <p>© 2026 FreeLancer 7776.link</p>
            </footer>

            {showCookiePopup && (
                <div className="cookie-popup" role="dialog" aria-live="polite" aria-label="Cookie Hinweis">
                    <p>
                        Wir verwenden Cookies, um die Nutzung der Website zu verbessern.
                        Du kannst Cookies akzeptieren oder ablehnen.
                    </p>
                    <div className="cookie-popup-actions">
                        <button type="button" className="decline-btn" onClick={handleDeclineCookies}>Ablehnen</button>
                        <button type="button" onClick={handleAcceptCookies}>Akzeptieren</button>
                    </div>
                </div>
            )}
        </>
    );
}

export default MainPage;
